<template>
<div>
    <div class="footerHome">
        <s-modal
            title="Version"
            :open="modalVersion"
            @close="modalVersion=false"
            :close="true"
        >
            <version />
        </s-modal>
        <div class="description">
            <s-l id="descriptionQSN">@2021 - petanque-app - Tous droits réservés</s-l><br/>
            <a   v-on:click="modalVersion=true">Versions</a>
            
        </div>
        <div class="buttonInfos">
           
            &nbsp;
            <a  @contextmenu="setUpload"  v-on:click="openFile('conditions')">Conditions d'utilisations</a>
           
        </div>
    </div>
    
    <s-modal
            title="Upload des fichiers"
            :open="openModalUpload"
            :close="true"
            @close="openModalUpload=false">
            <h1 class="title is-4">Upload des fichiers</h1><br/>
            Upload des mentions légales : <input type="file" name="mentions" @change="uploadFile" accept="pdf/*" /><br/><br/>
            Upload des conditions d'utilisations : <input type="file" name="conditions" @change="uploadFile" accept="pdf/*"/><br/><br/>
            Upload du fichier confidentialité : <input type="file" name="confidentialites" @change="uploadFile" accept="pdf/*"/><br/><br/>
    </s-modal>
        
    </div>
</template>
<style scoped>
    
    .footerHome a {
        font-size: 16px;
        color: black;
    }
    @media screen and (max-width: 1025px) {
        .buttonInfos {
             width:100%;
            display:inline-block;
            text-align:left;
        }
        .description {
            width:100%;
        }
        .footerHome {
        padding-top: 5px;
        padding-bottom: 5px;
        padding-left: 5px;
        padding-right: 5px;
        color: black;
    }
    }
    @media screen and (min-width: 1025px) {
        .footerHome {
        padding-top: 20px;
        padding-bottom: 20px;
        padding-left: 20px;
        padding-right: 80px;
        color: black;
    }
        .buttonInfos {
            width:50%;
            display:inline-block;
            text-align:right;
        }
        .description {
            width:50%;
            display:inline-block;
        }
    }
</style>
<script>
import firebase from 'firebase'; 
import version from '@/views/home/version.vue'; 
export default {
    data() {
        return {
            openModalUpload: false,
            openModalContact: false,
            fileData: null,
            uploadValue: null,
            modalVersion: false
        }
    },
    components: {
        version
    },
    methods: {
        setUpload(event) {
             event.preventDefault();
             if (this.$store.getters.getUser.adminSite) {
                this.openModalUpload = true;
             }
        },
        uploadFile (event) {
            this.uploadValue=0;
            this.fileData = event.target.files[0];
            var nameFile = event.target.attributes['name'].value;
            const storageRef = firebase.storage().ref(nameFile).put(this.fileData);
            storageRef.on(`state_changed`,snapshot=>{
                this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{console.log(error.message)},
            ()=>{this.uploadValue=100;
                storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                
                });
            }
            );
        },
        openFile(nameFile) {
            var storageRef  =  firebase.storage().ref(nameFile);
            storageRef.getDownloadURL()
                    .then((url) => {
                        // `url` is the download URL for 'images/stars.jpg'

                        // This can be downloaded directly:
                     
                         window.open(url);

                    })
                    .catch((error) => {
                        // Handle any errors
                    });
        }
    }
}
</script>
